/**
 * Created by Araja Jyothi Babu on 27-Oct-16.
 */
import React, {Component} from 'react';
import {Sunburst, Hint, LabelSeries } from 'react-vis';
import "react-vis/dist/style.css";
import { randomColorWithIndex } from '../../../../../../../../../utils';

const data = {
    name: "Root",
    children: [{"name":"Download_Start","count":2,"children":[{"name":"Download_Success","count":2,"children":[{"name":"Practise_Fragment_Added","count":2,"children":[{"name":"Start_Practise","count":2,"children":[]}]}]}]},{"name":"Practise_Fragment_Added","count":2,"children":[{"name":"Start_Practise","count":2,"children":[{"name":"Finish_Practise","count":2,"children":[{"name":"Start_Practise","count":2,"children":[]}]}]}]},{"name":"Volume_Click","count":23,"children":[{"name":"Adjust_Volume","count":23,"children":[{"name":"Volume_Click","count":3,"children":[{"name":"Adjust_Volume","count":3,"children":[]}]},{"name":"Adjust_Volume","count":20,"children":[{"name":"Interstitial_Load_Init","count":3,"children":[]},{"name":"Volume_Click","count":2,"children":[]},{"name":"Adjust_Volume","count":13,"children":[]},{"name":"Click_Pause","count":2,"children":[]}]}]}]},{"name":"Finish_Practise","count":126,"children":[{"name":"Start_Practise","count":64,"children":[{"name":"Finish_Practise","count":46,"children":[{"name":"Start_Practise","count":46,"children":[]}]},{"name":"Vocal_Range_Detector_Prompt_Shown","count":4,"children":[{"name":"Vocal_Range_Detector_Prompt_Dismiss","count":4,"children":[]}]},{"name":"Interstitial_Load_Fail","count":2,"children":[{"name":"Interstitial_Load_Fail","count":2,"children":[]}]},{"name":"Click_Pause","count":12,"children":[{"name":"Click_Resume","count":12,"children":[]}]}]},{"name":"Feedback_Generation","count":4,"children":[{"name":"Click_Practise_Again","count":4,"children":[{"name":"Start_Practise","count":4,"children":[]}]}]},{"name":"Start_Listen","count":58,"children":[{"name":"Stop_Listen","count":58,"children":[{"name":"Start_Practise","count":58,"children":[]}]}]}]},{"name":"Dashboard_Vitals_Loaded","count":17,"children":[{"name":"Daily_Bite_Click_Lesson","count":17,"children":[{"name":"Practise_Fragment_Added","count":17,"children":[{"name":"Start_Practise","count":17,"children":[]}]}]}]},{"name":"Click_Pause","count":48,"children":[{"name":"Volume_Click","count":2,"children":[{"name":"Finish_Practise","count":2,"children":[{"name":"Start_Practise","count":2,"children":[]}]}]},{"name":"Finish_Practise","count":17,"children":[{"name":"Start_Practise","count":17,"children":[{"name":"Interstitial_Load_Init","count":3,"children":[]},{"name":"Volume_Click","count":3,"children":[]},{"name":"Click_Pause","count":11,"children":[]}]}]},{"name":"Click_Resume","count":29,"children":[{"name":"Finish_Practise","count":10,"children":[{"name":"Interstitial_Load_Init","count":2,"children":[]},{"name":"Start_Practise","count":8,"children":[]}]},{"name":"Click_Pause","count":19,"children":[{"name":"Click_Resume","count":19,"children":[]}]}]}]},{"name":"Interstitial_Load_Success","count":3,"children":[{"name":"Click_Pause","count":3,"children":[{"name":"Finish_Practise","count":3,"children":[{"name":"Start_Practise","count":3,"children":[]}]}]}]},{"name":"Vocal_Range_Detector_Prompt_Shown","count":38,"children":[{"name":"Vocal_Range_Detector_Prompt_Dismiss","count":9,"children":[{"name":"Volume_Click","count":3,"children":[{"name":"Adjust_Volume","count":3,"children":[]}]},{"name":"Click_Pause","count":6,"children":[{"name":"Click_Resume","count":6,"children":[]}]}]},{"name":"Vocal_Range_Detector_Prompt_Proceed","count":29,"children":[{"name":"Vocal_Range_Detector_Prompt_Result","count":29,"children":[{"name":"Vocal_Range_Detector_Prompt_Dismiss","count":29,"children":[]}]}]}]}]
};

const LABEL_STYLE = {
    fontSize: '12px',
    textAnchor: 'middle'
};

/**
 * Recursively work backwards from highlighted node to find path of valud nodes
 * @param {Object} node - the current node being considered
 * @returns {Array} an array of strings describing the key route to the current node
 */
function getKeyPath(node) {
    if (!node.parent) {
        return [];
    }
    const d = (node.data && node.data) || node;
    const pathItem = d.name + "(" + d.count + ")";
    return [pathItem].concat(
        getKeyPath(node.parent)
    );
}

/**
 * Recursively modify data depending on whether or not each cell has been selected by the hover/highlight
 * @param {Object} data - the current node being considered
 * @param {Object|Boolean} keyPath - a map of keys that are in the highlight path
 * if this is false then all nodes are marked as selected
 * @returns {Object} Updated tree structure
 */
function updateData(data, keyPath) {
    if (data.children) {
        data.children.map(child => updateData(child, keyPath));
    }
    // add a fill to all the uncolored cells
    if (!data.hex) {
        const name = data.name || "";
        data.style = {
            fill: randomColorWithIndex(name.length)
        };
    }
    data.style = {
        ...data.style,
        fillOpacity: keyPath && !keyPath[data.name + "(" + data.count + ")"] ? 0.2 : 1
    };

    return data;
}

const decoratedData = updateData(data, false);



export class PathGraph extends React.Component {

    constructor(props){
        super(props);
        const { data } = this.props;
        this.state = {
            pathValue: false,
            data: updateData(data, false),
            finalValue: false,
            clicked: false
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({data: updateData(nextProps.data, false)});
    }

    render(){
        const {clicked, data, finalValue, pathValue} = this.state;
        return(
            <div style={{minHeight: 450, textAlign: '-webkit-center'}}>
                <Sunburst
                    animation
                    className="item-center"
                    hideRootNode
                    onValueMouseOver={node => {
                        if (clicked) {
                            return;
                        }
                        const path = getKeyPath(node).reverse();
                        const pathAsMap = path.reduce((res, row) => {
                            res[row] = true;
                            return res;
                        }, {});
                        this.setState({
                            finalValue: path[path.length - 1],
                            pathValue: path.join(' > '),
                            data: updateData(data, pathAsMap)
                        });
                    }}
                    onValueMouseOut={() =>
                        clicked
                            ? () => {}
                            : this.setState({
                                pathValue: false,
                                finalValue: false,
                                data: updateData(data, false)
                            })
                    }
                    onValueClick={() => this.setState({clicked: !clicked})}
                    style={{
                        stroke: '#ddd',
                        strokeOpacity: 0.3,
                        strokeWidth: '0.5'
                    }}
                    colorType="literal"
                    getSize={d => d.count}
                    getColor={d => d.hex}
                    data={data}
                    height={350}
                    width={400}
                >
                    {finalValue && (
                        <LabelSeries
                            data={[{x: 0, y: 0, label: finalValue, style: LABEL_STYLE}]}
                        />
                    )}
                </Sunburst>
                <h4>{pathValue}</h4>
            </div>
        )
    }
}